var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonday = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 66,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#monday_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFCB00",
  d: "M33.1 39.524c-2.843-.069-5.188-1.315-6.686-3.915-1.535-2.688-1.468-5.44.169-8.061 3.896-6.24 7.844-12.444 11.767-18.665.802-1.272 1.586-2.563 2.426-3.812a7.86 7.86 0 0 1 4.854-3.366 7.9 7.9 0 0 1 5.843.952c3.693 2.26 4.929 6.962 2.629 10.667a1571 1571 0 0 1-14.305 22.705c-1.49 2.33-3.75 3.453-6.697 3.495"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3D57",
  d: "M8.684 39.524c-2.87-.069-5.202-1.37-6.67-3.96-1.514-2.688-1.418-5.445.224-8.067Q8.526 17.477 14.87 7.488c.535-.86 1.07-1.742 1.642-2.576a7.87 7.87 0 0 1 4.934-3.224 7.9 7.9 0 0 1 5.802 1.095 7.81 7.81 0 0 1 3.4 4.797 7.77 7.77 0 0 1-.922 5.794C25.04 20.89 20.29 28.377 15.538 35.857c-1.543 2.425-3.814 3.626-6.854 3.668"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00D647",
  d: "M57.675 24.294c4.324.021 7.825 3.434 7.817 7.62 0 4.25-3.594 7.677-7.959 7.624-4.364-.053-7.804-3.43-7.798-7.634.005-4.266 3.52-7.637 7.94-7.61"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "monday_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h65v40H.5z"
})))));
export { SvgMonday as ReactComponent };
export default __webpack_public_path__ + "static/media/monday.0f15608f.svg";